import Tippy from '@tippyjs/react';

import {
  ASSURANCE_THRESHOLD_MAX,
  ASSURANCE_THRESHOLD_MIN
} from 'lib/constants/healthcareProgram/eligibilitySetup';

import Badge from 'components/shared/Badge/Badge';
import Icon from 'components/shared/Icon/Icon';
import Input from 'components/shared/Input/Input';
import Slider from 'components/shared/Slider/Slider';
import Typography from 'components/shared/Typography/Typography';

const clampThreshold = (n) =>
  Math.max(ASSURANCE_THRESHOLD_MIN, Math.min(ASSURANCE_THRESHOLD_MAX, Number(n) || 0));

const AssuranceRatingSection = ({ value, onChange }) => {
  return (
    <section className="flex w-full flex-col gap-3">
      <div className="flex items-center gap-2">
        <Typography size="large" weight="medium">
          Assurance rating rules
        </Typography>
        <Badge
          icon="status-mono"
          text="Patent pending"
          color="violet"
          size="small"
          className="px-2"
        />
      </div>
      <Typography size="small" color="neutral-700">
        Set the minimum confidence thresholds Myriad uses when surfacing eligibility results and
        finalizing Good Faith Estimates.
      </Typography>

      <div className="mt-4 flex flex-col gap-2">
        <div className="flex items-center justify-between gap-1">
          <div className="flex items-center justify-between gap-1">
            <Typography size="xs" color="neutral-800" weight="medium">
              Minimum score to auto-finalize GFE
            </Typography>
            <Tippy
              content="Myriad finalizes a GFE automatically when the assurance rating meets your threshold."
              className="tippy-dark">
              <span>
                <Icon icon="info-mono" size={16} color="neutral-500" />
              </span>
            </Tippy>
          </div>

          <Typography size="xs" color="neutral-500" weight="medium">
            Max: 95%
          </Typography>
        </div>

        <div className="flex items-center gap-3">
          <Input
            id="assurance-threshold-input"
            type="number"
            min={ASSURANCE_THRESHOLD_MIN}
            max={ASSURANCE_THRESHOLD_MAX}
            value={value}
            rightText="%"
            onChange={(e) => onChange(clampThreshold(e.target.value))}
          />
          <div className="flex-1">
            <Slider
              value={value}
              onChange={onChange}
              min={ASSURANCE_THRESHOLD_MIN}
              max={ASSURANCE_THRESHOLD_MAX}
              step={1}
              isTippy={false}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AssuranceRatingSection;
